
import axios from 'axios'

export const getUser = async(organizationId, userId) => {
    const response = await axios.get(`/organization/${organizationId}/user/${userId}`)
    // console.log(response)
    return response.data
}
export const getUserAddress = async(userId, page = 0 , pageSize = 10) => {
    const response = await axios.get(
        `/users/${userId}/addresses?page=${page + 1}&pageSize=${pageSize}`
    );
    if (response.data.length === 0) return {results: [], count: 0}
    const data = {
        results: response.data.data,
        count: response.data.total
    };
    // console.log(data)
    return data;
}
const USER_STATUS_PENDING_DEACTIVATION = 4;
export { USER_STATUS_PENDING_DEACTIVATION };
